import { useState } from 'react';
import { AppDialogVariant } from '../components/Common/AppDialogMessage';

type DialogState = {
    open: boolean;
    title?: string;
    message: React.ReactNode;
    variant: AppDialogVariant;
    confirmText?: string;
    cancelText?: string;
    hideCancel?: boolean;
    onConfirm?: () => void;
};

export function useAppDialog() {
    const [dialog, setDialog] = useState<DialogState>({
        open: false,
        message: '',
        variant: 'info',
    });

    const openDialog = (config: Omit<DialogState, 'open'>) => {
        setDialog({ ...config, open: true });
    };

    const closeDialog = () => {
        setDialog((prev) => ({ ...prev, open: false }));
    };

    return {
        dialog,
        openDialog,
        closeDialog,
    };
}